<div class="container">
  <div class="box">
    <div class="row">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-2 p-1">
            <b>Call Transaction ID*:</b>
          </div>
          <div class="col-sm-4 p-1 d-flex align-items-center">
            <input id="sip" placeholder="Enter call transaction id" pInputText class="form-control" aria-label="card"
              type="text" [(ngModel)]="sip" name="sip">
            <span>&nbsp;</span>
          </div>
          <div class="col-sm-2 p-1">
            <button class="btn btn-info"
          [disabled]="sessionStarted || !sip" 
          (click)="startCapturePayment(); sessionStarted = true; eventTriggered=''">Start
              Session</button>
          </div>
          <div class="col-sm-3 p-1 align-items-left">
            <button class="btn btn-outline-info" 
          [disabled]="!pksid"
          (click)="completeOrCancelPayment('cancel'); eventTriggered=''">Clear Session</button>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="box">
    <div class="row">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-2 p-1 center-icons">
            <b>Card:</b>       
            <i class="icon-card-visa"></i>
            <i class="icon-card-mastercard"></i>   
          </div>
          <div class="col-sm-4 p-1 d-flex align-items-center">

            <input class="form-control" aria-label="card" type="text" [(ngModel)]="cardNumber" name="cardNumber"
              readonly> <span id="payment-card-number"><i class="icon fa fa-exclamation-circle text-danger"></i></span>
          </div>
          <div class="col-sm-3 p-1">
            <button class="btn" [ngClass]="eventTriggered == 'CN' ? 'btn-info':'btn-outline-info'" [disabled]="!sessionStarted || !pksid || timeLeftForCardNumber > 0"
              (click)="startCaptureCard('payment-card-number');eventTriggered='CN'">{{timeLeftForCardNumber >0 ? 'Time left: ' + timeLeftForCardNumber:'Capture/Reset'}}</button>
          </div>
          
        </div>
        <div class="row">
          <div class="col-sm-2 p-1">
            <b>CVV:</b>
          </div>
          <div class="col-sm-4 p-1 d-flex align-items-center">
            <input class="form-control" aria-label="cvc" type="text" id="cvc" [(ngModel)]="cvv" name="cvv" readonly>
            <span id="security-code"><i class="icon fa fa-exclamation-circle text-danger"></i></span>
          </div>
          <div class="col-sm-3 p-1">
            <button class="btn" [ngClass]="eventTriggered == 'SC' ? 'btn-info':'btn-outline-info'" [disabled]="!sessionStarted || !pksid || timeLeftForCVV > 0"
              (click)="startCaptureCard('security-code');eventTriggered='SC'">{{timeLeftForCVV >0 ? 'Time left: ' + timeLeftForCVV:'Capture/Reset'}}</button>

          </div>
        </div>

        <div class="row">
          <div class="col-sm-2 p-1">
            <b>Expiry (MMYY):</b>
          </div>
          <div class="col-sm-4 p-1 d-flex align-items-center">
            <input class="form-control" aria-label="date" type="text" id="expiryDate" [(ngModel)]="expiryDate"
              name="expiryDate" readonly>
            <span id="expiration-date"><i class="icon fa fa-exclamation-circle text-danger"></i></span>
          </div>
          <div class="col-sm-3 p-1">
            <button class="btn" [ngClass]="eventTriggered == 'ED' ? 'btn-info':'btn-outline-info'" [disabled]="!sessionStarted || !pksid || timeLeftForEXP > 0"
              (click)="startCaptureCard('expiration-date');eventTriggered='ED'">{{timeLeftForEXP >0 ? 'Time left: ' + timeLeftForEXP:'Capture/Reset'}}</button>

          </div>
        </div>
        <div class="row">
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="box" *ngIf="sessionStarted && !paymentToken">
    <div class="row">    
      <div class="col-sm-3 p-1">
        <button 
        class="btn btn-info"
        [disabled]="checkIfCardCapturedInvalid()" 
        (click)="completeOrCancelPayment('complete')">Complete
          Session</button>
      </div>    
      <div *ngIf="completePaymentStarted" class="col-sm-4 p-2">
        <p-progressBar mode="indeterminate"></p-progressBar>
      </div>
    </div>
  </div> -->
  <div class="action-button-wrapper text-center text-lg-start" *ngIf="sessionStarted && !checkIfCardCapturedInvalid()">
    <span>
      <button data-auto-id="paymentBtn" class="btn btn-info btn-lg px-5 wdthfix mt-2" (click)="completeOrCancelPayment('complete')"
       >
        Confirm & Pay <i class="fa fa-chevron-right pl-2"></i>
      </button>
    </span>

  </div>

  <!-- Modal popup -->
  <div class="modal-overlay" *ngIf="callMessage">
    <div class="modal-content">
      <div class="modal-header">
        <h2>Message</h2>
        <button class="close-button" (click)="onClose()">✖</button>
      </div>
      <div class="modal-body">
        <p>{{ callMessage }}</p>
      </div>
    </div>
  </div>
  <p-dialog header="Alert" [(visible)]="unsuccessfulMessage" [modal]="true" [closable]="false"
    [dismissableMask]="false">
    <p>
      {{ unsuccessfulMessage }}
    </p>
    <p-footer>
      <button class="btn btn-info btn-lg px-5 wdthfix" (click)="hideUnsuccessfulAlert()">
        Ok
      </button>
    </p-footer>
  </p-dialog>
</div>